import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthCard from './AuthCard';
import AuthInput from './AuthInput';
import AuthButton from './AuthButton';
import SocialLoginButton from './SocialLoginButton';
import { toast } from 'sonner';
import Logo from "../../assets/images/logo.png"

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [rememberMe, setRememberMe] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    toast.success("Login successful!");
  };

  const handleSocialLogin = (provider) => {
    console.log(`Login with ${provider}`);
    toast.info(`${provider} login would happen here`);
  };

  return (
    <AuthCard
      logo={Logo}
      title="Kyçuni"
      subtitle="Identifikohuni për të vazhduar në llogarinë tuaj."
    >
      <form onSubmit={handleSubmit}>
        <AuthInput
          label="Email"
          type="email"
          name="email"
          placeholder="email@example.com"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <AuthInput
          label="Password"
          type="password"
          name="password"
          placeholder="********"
          value={formData.password}
          onChange={handleChange}
          required
        />

        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <input
              id="remember-me"
              name="remember-me"
              type="checkbox"
              checked={rememberMe}
              onChange={() => setRememberMe(!rememberMe)}
              className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
            />
            <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700">
              Më mbaj të kyçur
            </label>
          </div>

          <div className="text-sm">
            <a href="#" className="font-medium text-red-600 hover:text-red-500">
              Forgot password?
            </a>
          </div>
        </div>

        <div className="mb-6">
          <AuthButton type="submit" variant="primary">
            Login
          </AuthButton>
        </div>
      </form>

      <div className="relative mb-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-white text-gray-500">or</span>
        </div>
      </div>

      <div className="space-y-3 mb-6">
        <SocialLoginButton provider="google" onClick={() => handleSocialLogin('Google')} />
        <SocialLoginButton provider="facebook" onClick={() => handleSocialLogin('Facebook')} />
      </div>

      <p className="text-center text-sm text-gray-600">
        Nuk keni një llogari?{' '}
        <Link to="/register" className="font-medium text-red-600 hover:text-red-500">
          Regjistrohu
        </Link>
      </p>
    </AuthCard>
  );
};

export default Login;